import { Card, CardContent, Skeleton, Theme, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
	title: string;
	description?: string;
	icon?: ReactNode | null;
	color: keyof Theme['palette'];
}

export default function InformationCard({ title, description, icon = null, color }: IProps) {
	let backgroundIconColor = 'bg-primary-50';
	let iconColor = 'text-primary-200';
	let borderColor = `border-primary-200`;
	switch (color) {
		case 'green':
			backgroundIconColor = 'bg-green-50';
			iconColor = 'text-green-200';
			borderColor = 'border-green-200';
			break;
		case 'orange':
			backgroundIconColor = 'bg-orange-50';
			iconColor = 'text-orange-200';
			borderColor = 'border-orange-200';
			break;
		case 'secondary':
			backgroundIconColor = 'bg-secondary-50';
			iconColor = 'text-secondary-200';
			borderColor = 'border-secondary-200';
			break;
	}
	return (
		<Card className={`border-b-2 ${borderColor}`}>
			<CardContent className="flex flex-col gap-6">
				<div className="flex flex-row justify-between">
					<Typography className="text-base text-text-secondary">{title}</Typography>
					{icon && <div className={`rounded-md p-1.5 ${backgroundIconColor} ${iconColor}`}>{icon}</div>}
				</div>
				<Typography className="text-2xl font-medium">{description ?? <Skeleton />}</Typography>
			</CardContent>
		</Card>
	);
}
